export const environment = {
  production: false,
  apiUrl: 'https://staging.signup.api.rackspacecloud.com',
  recaptchaSiteKey: '6LdJxo4fAAAAAJtWVl7K_xL_afGqg40FLUAJRk4-',
  pfwaURL: "https://staging.forms.payment.api.rackspacecloud.com/v1/forms/method_capture/signup",
  mockSignup: true,
  gtmKey: "GTM-NBRLW2GQ"
};
